import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'

export const mutateShowcaseUpdate = ({ showcaseId }) => {

    const mutation = useMutation({
        mutationKey: ['showcase-update', showcaseId],
        mutationFn: async (formData) => {
            const res = await axios.put(route('studio.v1.api.showcases.update', showcaseId), formData);
            return res;
        },
        onSuccess: async ({ data }) => {
            notifications.show({
                color: 'green',
                title: data?.message,
              })
        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || "",
              })
        }
    });  

    return mutation;
}